import { useEffect, useState, useRef, useCallback } from 'react'
import Index from './index'
import MyOrderOperation from '../../../redux/MyOrder/operations'
import userProfileSelectors from '../../../redux/UserProfile/selectors'
import userOperations from '../../../redux/UserProfile/operations'
import { operations } from 'redux/Navigation';
import { useDispatch, useSelector } from 'react-redux'
import { setHeaderNav } from '../../../redux/MyOrder/action'
import { useNavigate } from 'react-router-dom'
import userSelectors from 'redux/UserProfile/selectors';
import navSelectors from 'redux/Navigation/selectors';
import Moment from 'moment';
import OrderDispatch from 'Store/OrderManagement/Order/OrderDispatch'
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction'
import TransferOrderDispatch from 'Store/Transfer/Transfer/TransferOrderByIdDispatch'
import TransferAction from 'Store/Component/Transfer/TransferAction';
import { CONSTANTS } from 'client/utils/constants'
import navOperations from "redux/Navigation/operations"
import { setDeleteCartOrder } from 'Store/OrderManagement/Order/OrderAction';
import { getUserEquipmentOrdererRole } from 'Store/Identity/UserProfiles/UserProfileAction'
import addrequest from '../../assets/images/Add Request.svg'
import myticket from '../../assets/images/Ticket.svg';
import { GetOnOrderIdClickedUrl } from 'client/Components/OrderManagement/mainUtil';
import confirmationBee from '../../assets/images/ConfirmationBee.svg'
import { getSaveDefaultLocation, setISSaveDefaultLocation } from 'Store/Identity/DefaultLocation/DefaultLocationAction'

const HeaderContainer = (props: any) => {
  const dispatch = useDispatch();
  const dispatchGetBranch = MyOrderOperation.dispatchGetBranch(dispatch);
  const dispatchBranchDetails = MyOrderOperation.dispatchBranchDetails(dispatch);
  const dispatchGetUserDetails = userOperations.dispatchGetUserDetail(dispatch);
  const getOrderDetailById = OrderDispatch.dispatchGetOrderById(dispatch);
  const getTransferOrderDetailById = TransferOrderDispatch.dispatchGetTransferOrderById(dispatch);
  const dispatchHeaderNav = navOperations.dispatchHeaderNav(dispatch);
  const dispatchGetDeleteCartOrderById = OrderDispatch.dispatchGetDeleteCartOrder(dispatch);
  const dispatchSetDeleteCartOrder = OrderDispatch.dispatchSetDeleteCartOrder(dispatch);
  const dispatchGetCartOrders = OrderDispatch.dispatchGetCartOrders(dispatch);
  const dispatchGetCartCount = OrderDispatch.dispatchGetCartCount(dispatch);

  const [showUserProfilePopup, setShowUserProfilePopup] = useState(false)
  const [showBranchDrpdown, setshowBranchDrpdown] = useState<boolean>(false)
  const [showAlertNotificationPopup, setAlertNotificationPopup] = useState<boolean>(false)
  const [showMyCartPopup, setShowMyCartPopup] = useState<boolean>(false)
  const [isCartLinkClicked, setIsCartLinkClicked] = useState(false);
  const [showZohoAccessPopup, setShowZohoAccessPopup] = useState(false);
  const [infoSection, setInfoSection] = useState<any>([]);
  const [isDeleteCartClicked, setIsDeleteCartClicked] = useState<any>(false);
  const [defaultLocationTemp, setDefaultLocationTemp] = useState<any>({});
  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comment: "",
    popupOutlinebtnOnclick: () => { },
    popupPrimarybtnOnclick: () => { }
  });

  const [deletePopup, setDeletePopup] = useState(false);
  const wrapperRef = useRef<any>(null);
  const navDispatch = operations.dispatchNav(dispatch);
  let navigate = useNavigate();
  const webAppBaseUrl = process.env.REACT_APP_WEBAPP_API_BASE_URL;
  const getEnv = () => {
    if (webAppBaseUrl?.includes('dev')) {
      return 'DEV'
    }else if (webAppBaseUrl?.includes('test')) {
      return 'TEST'
    }else if (webAppBaseUrl?.includes('qa')) {
      return 'QA'
    }else if (webAppBaseUrl?.includes('staging')) {
      return 'STAGING'
    }else if (webAppBaseUrl?.includes('uat')) {
      return 'UAT'
    }else if (webAppBaseUrl?.includes('local')) {
      return 'LOCAL'
    }else {  
      return 
    }
  }
  const env = getEnv()
  
  const {
    BranchList,
    userDetails,
    menu,
    BranchDetails,
    nav,
    cartOrders,
    cartOrderDelete,
    orderId,
    currentUser,
    isSaveDefaultLocation
  }: any = useSelector(
    (state: any) => ({
      BranchList: userSelectors.BranchList(state),
      userDetails: userProfileSelectors.getUserDetails(state),
      menu: state.nav.showMenu,
      BranchDetails: state.GetBranchDetails.BranchDetails,
      nav: navSelectors.GetNavItem(state),
      cartOrders: state.OrderReducer.cartOrders,
      cartOrderDelete: state.OrderReducer.cartOrderDelete,
      orderId: state.RequisitionReducer.orderId,
      currentUser: state.UserReducer.currentUser,
      isSaveDefaultLocation: state.UserDefaultLocationReducer.isSaveDefaultLocation
    }));

    const getUserRoles = () => {
      let roles = userDetails?.roles?.map((role:any) => role.roleName)
      return roles
    }

    const [successAlert, setSuccessAlert] = useState(false);
  useEffect(() => {
   if(currentUser.currentUserName){
      dispatchGetUserDetails({ user: currentUser.currentUserName })
    }
  }, [currentUser.currentUserName]);

  useEffect(() => {
    if(Object.keys(userDetails)?.length){
    if ((!getUserRoles()?.includes(CONSTANTS?.FLEET_ADMIN) &&
      !getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN) &&
      !getUserRoles()?.includes(CONSTANTS?.EQUIPMENT_ORDERER)) || 
        !userDetails?.emailId) {
        dispatch(getUserEquipmentOrdererRole(currentUser.currentUserName))
    }
  }
      dispatchGetBranch({
        user: userDetails?.emailId
      })

      const InfoSectionTemp = [
        {
          id:1,
          text:userDetails?.zohoText1,
          icon:addrequest,
          url: userDetails?.zohoText1Link
        },
        {
          id:2,
          text:userDetails?.zohoText2,
          icon:myticket,
          url: userDetails?.zohoText2Link
        }
      ]
      setInfoSection(InfoSectionTemp)
  }, [userDetails?.emailId])

  useEffect(() => {
    if (showMyCartPopup) {
        dispatchGetCartOrders(userDetails?.emailId)
    }
  }, [showMyCartPopup])

  useEffect(() => {
    if(cartOrderDelete && isDeleteCartClicked){
      dispatchGetCartCount(userDetails?.emailId)
      dispatchGetCartOrders(userDetails?.emailId)
    }
    if(cartOrderDelete !== "" && cartOrderDelete !== undefined && isDeleteCartClicked){
      setSuccessAlert(cartOrderDelete)
    }
    setTimeout(() => {
      if(cartOrderDelete && isDeleteCartClicked)
      dispatch(setDeleteCartOrder(false))
    }, 30000) 
    setIsDeleteCartClicked(false)
  },[cartOrderDelete])

  useEffect(() => {
    if (Object.keys(userDetails).length && BranchList?.length) {
    if(userDetails?.defaultLocation != null){
      let BranchListExt = BranchList?.length ? BranchList?.find((branch: any) => branch.costCenter === userDetails?.defaultLocation) : {}
      BranchListExt = { name: BranchListExt?.branchName, branchId: BranchListExt?.branchNo, branchNumber: BranchListExt?.costCenter, companyName: BranchListExt?.companyName }
      dispatchBranchDetails(BranchListExt)
      setDefaultLocationTemp(BranchListExt)
    }else{
      let BranchListExt = BranchList?.length ? BranchList[0] : {}
      BranchListExt = { name: BranchListExt?.branchName, branchId: BranchListExt?.branchNo, branchNumber: BranchListExt?.costCenter, companyName: BranchListExt?.companyName }
      dispatchBranchDetails(BranchListExt)
      setDefaultLocationTemp(BranchListExt)
    }
    }

  }, [userDetails?.emailId, BranchList])

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleClickOutsideAlertNotification, false);
    return () => {
      document.removeEventListener("click", handleClickOutsideAlertNotification, false);
    };
  }, []);
    
  const handleLogout = (e: any) => {  
    e.preventDefault()
    window.location.href = `${webAppBaseUrl}api/Auth/Logout`;
  }  

  const hidePopup = () => {
    setShowUserProfilePopup(false)
  }
  const ShowPopup = (e: any) => {
    e.preventDefault()
    setShowUserProfilePopup(true)
  }

  const handleClickBranch = () => {
    setshowBranchDrpdown(true)
  }

  const handleClickAlertNotification = () => {
    setAlertNotificationPopup(true)
  }

  useEffect(() => {
    if (isSaveDefaultLocation != null) {
      if (isSaveDefaultLocation) {
        dispatchBranchDetails(defaultLocationTemp)
      } else {
        setDefaultLocationTemp(BranchDetails)
      }
      dispatch(setISSaveDefaultLocation(null))
    }
  }, [isSaveDefaultLocation])

  const handleClick = (item: any) => {
    setDefaultLocationTemp(item)
    dispatch(getSaveDefaultLocation({
      userId: userDetails?.userId.toString(),
      savedBy: userDetails?.emailId,
      defaultLocation: item.branchNumber,

    }))
  }

  const cartClick = (e: any) => {
    e.preventDefault()
    if (e.currentTarget.baseURI.includes('OrderManagement') || e.currentTarget.baseURI.includes('orderManagement') || e.currentTarget.baseURI.includes('ordermanagement')) {
      navDispatch('Customer My Orders')
    } else {
      navDispatch('Customer My Orders')
      let path = `OrderManagement`;
      navigate(path);
    }
  }
  useEffect(() => {

    if (window.location.href.includes('OrderManagement')
      || window.location.href.includes('orderManagement')
      || window.location.href.includes('ordermanagement')
      || window.location.href.toLowerCase().includes('CreateOrder'.toLowerCase())
      || window.location.href.includes('requisitionorderapproval')
      || window.location.href.includes('assetorderapproval')
      || window.location.href.toLowerCase().includes('requisitionOrderDetail'.toLowerCase())
      || window.location.href.toLowerCase().includes('BulkOrder'.toLowerCase())
      || window.location.href.toLowerCase().includes('assetOrderDetail'.toLowerCase())) {
      dispatch(setHeaderNav(true))
    }
    else {
      dispatch(setHeaderNav(false))
    }
  }, [window?.location?.href]);


  const myCartValues = cartOrders?.myDraftOrders?.map((item: any) =>
    ({ requestType: (item?.isBulkOrder ? CONSTANTS.BULK_ORDER : item?.orderType), savedDate: Moment(item?.updatedDate).format("MM/DD/YYYY"), orderId: item?.orderId, isBulkOrder: item?.isBulkOrder })
  );

  const navigateToPage = (e?: any, requestType?: any, orderId?: any, isBulkOrder?: any) => {
    e.preventDefault();
    setIsCartLinkClicked(true);
    setShowMyCartPopup(false)
    dispatch(RequisitionAction.setIsChangesOccured(false));
    dispatch(TransferAction.setIsChangesOccuredInCart(false))
    if (requestType == CONSTANTS?.TRANSFER || requestType == CONSTANTS?.DISPOSITION || requestType == CONSTANTS?.REACTIVATION || requestType == CONSTANTS?.AFEREQUEST) {
      dispatch(TransferAction.setIsEditOrder(true))
      getTransferOrderDetailById(orderId)
      navigate('/ordermanagement/assetcreateorder/' + orderId + "/home" + "/" + requestType);
      dispatchHeaderNav("Home");
    } else {
      if(isBulkOrder){
        let navigationUrl =  GetOnOrderIdClickedUrl(CONSTANTS?.ORDER_STATUS?.UNSUBMITTED, CONSTANTS?.BULK_ORDER_GRID, orderId, isBulkOrder, 'home', "");
        navigate(navigationUrl);
      }else{
      getOrderDetailById(orderId)
      navigate('/ordermanagement/createorder/' + orderId + "/home");
      }
      dispatch(RequisitionAction.setIsEditOrder(true))
      dispatchHeaderNav("Home");
    }

  }

  const handleClickOutside = (event: any) => {
    if (!event.target.closest('.custom-dropdown-menu') && !event.target.closest('.modalPopupMasterContainer')) {
      if (event.target.closest('.branch-drpdown')) {
        setshowBranchDrpdown(true)
      }
      else {
        setshowBranchDrpdown(false)
      }
    }
  }
  const handleClickOutsideAlertNotification = (event: any) => {
    if (event.target.closest('.alert-notification')) {
      setAlertNotificationPopup(true)
    }
    else {
      setAlertNotificationPopup(false)
    }
  }

  // MyCart Popup Hide/Show
  const handleClickMyCart = () => {
    setShowMyCartPopup(true)
  }

  useEffect(() => {
    if (isCartLinkClicked) {
      setShowMyCartPopup(false);
      setIsCartLinkClicked(false);
    }
  }, [isCartLinkClicked])

  useEffect(() => {
    document.addEventListener("click", handleClickOutsideMyCart, false);
    return () => {
      document.removeEventListener("click", handleClickOutsideMyCart, false);
    };
  }, []);

  const handleClickOutsideMyCart = (event: any) => {
    if (event.target.closest('.cartsection-block')) {
      setShowMyCartPopup(true)
    }
    else {
      setShowMyCartPopup(false)
    }
  }

  const deleteCartDraftOrder = (ItemId?: any, comment?: any) => {
    dispatchSetDeleteCartOrder(false);
    const deleteDraftOrder = {
      orderId: ItemId,
      comments: comment,
      savedBy: userDetails?.emailId
    };
    setIsDeleteCartClicked(true)
    dispatchGetDeleteCartOrderById(deleteDraftOrder)
    if(orderId == ItemId){
      dispatch(TransferAction.setIsEditOrder(false))
      dispatch(RequisitionAction.setIsChangesOccured(false));
      dispatch(TransferAction.setIsChangesOccuredInCart(false))
      navigate('/ordermanagement')
    }
    setDeletePopup(false);
  }

  const dismissSuccessAlert = () => {
    dispatch(setDeleteCartOrder(false))
  }
  
  const handleInfoSection = () => {
    setShowZohoAccessPopup(true)
  }

  const hideZohoAccessPopup = () => {
    setShowZohoAccessPopup(false)
  }

  const hideConfirmationDialog = useCallback(
    () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
    [Popupcontent]
  );

  const onDraftDeleteClick = (e: any, ItemId: any) => {
    e.preventDefault();
    e.stopPropagation()
    let decriptionTxt = (
      <>
        <p>Are you sure you want to delete this draft?</p>
      </>
    );
    setPopupcontent({
      ...Popupcontent,
      titleImg: confirmationBee,
      title: "Confirmation",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isCommentboxVisible: true,
      isCommentBoxRequire: true,
      isSingleConfirmationBtn: false,
      popupOutlinebtnOnclick: () => {
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
      },
      popupPrimarybtnOnclick: (item: any,
        comment: string,
        actionby: string,
        value: any) => {
          deleteCartDraftOrder(ItemId, comment)
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
      }
    });
    setDeletePopup(ItemId)
  }

  return <Index
    BranchList={BranchList}
    userDetails={userDetails}
    handleClickBranch={handleClickBranch}
    menu={menu}
    wrapperRef={wrapperRef}
    showBranchDrpdown={showBranchDrpdown}
    handleClick={handleClick}
    ShowPopup={ShowPopup}
    handleLogout={handleLogout}
    showUserProfilePopup={showUserProfilePopup}
    hidePopup={hidePopup}
    heading={props?.heading}
    showMenu={props?.showMenu}
    toggleDropdown={props?.toggleDropdown}
    userMenuList={props?.userMenuList}
    cartClick={cartClick}
    nav={nav}
    showAlertNotificationPopup={showAlertNotificationPopup}
    setAlertNotificationPopup={setAlertNotificationPopup}
    handleClickAlertNotification={handleClickAlertNotification}
    showMyCartPopup={showMyCartPopup}
    handleClickMyCart={handleClickMyCart}
    myCartValues={myCartValues}
    navigateToPage={navigateToPage}
    deleteCartDraftOrder={deleteCartDraftOrder}
    deletePopup={deletePopup}
    successAlert={successAlert}
    cartOrderDelete={cartOrderDelete}
    dismissSuccessAlert={dismissSuccessAlert}
    showZohoAccessPopup={showZohoAccessPopup}
    hideZohoAccessPopup={hideZohoAccessPopup}
    handleInfoSection={handleInfoSection}
    InfoSection={infoSection} 
    onDraftDeleteClick = {onDraftDeleteClick}   
    Popupcontent = {Popupcontent}
    hideConfirmationDialog = {hideConfirmationDialog}
    isDeleteCartClicked = {isDeleteCartClicked}
    defaultLocationTemp = {defaultLocationTemp}
    env={env}
  />
}

export default HeaderContainer
